import { type ImagePickerAsset, type ImagePickerOptions, type ImagePickerResult, launchImageLibraryAsync } from "expo-image-picker";
import { type ReactNode, useState } from "react";
import { YStack, type YStackProps } from "./Stacks";
type Props = Omit<YStackProps, "children"> & {
  onImageSelected: (assets: ImagePickerAsset[], setButtonLoading: (loading: boolean) => void) => void;
  children: (isLoading: boolean) => ReactNode;
};
const imagePickerOptions: ImagePickerOptions = {
  allowsEditing: false,
  mediaTypes: ["images"],
  allowsMultipleSelection: true,
  // Default compression
  // 0 means compress for small size, 1 means compress for maximum quality
  quality: 0.8
};
export const ImagePickerButton = ({
  onImageSelected,
  children,
  ...rest
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const pickImageAsync = async () => {
    setIsLoading(true);
    try {
      // This library will launch the model slower than expected and close the
      // modal before the promise resolves. We pass the button loading function
      // so it fires at the same time the drawer closes
      let result: ImagePickerResult;
      result = await launchImageLibraryAsync(imagePickerOptions);
      if (result && !result.canceled) {
        onImageSelected(result.assets, setIsLoading);
      } else {
        setIsLoading(false);
      }
    } catch {
      setIsLoading(false);
      console.error("Error picking image");
    }
  };
  return <YStack theme="granted" disabled={isLoading} jc="flex-start" w="100%" p="$4" cursor="pointer" onPress={pickImageAsync} {...rest} data-sentry-element="YStack" data-sentry-component="ImagePickerButton" data-sentry-source-file="ImagePickerButton.tsx">
      {children?.(isLoading)}
    </YStack>;
};